import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';

const Icon = ({icon, ...props}) => {
  return (
    <FontAwesomeIcon icon={icon} {...props} /> 
  )
}

export default Icon